module.exports = __webpack_public_path__ + "static/media/RP-B_S_Jacquard_Vela_DK Grey_LT Grey.0a31d647.png";